import type { OperationVariables, TypedDocumentNode } from '@apollo/client'
import { useSubscription } from '@apollo/client/react'
import { getToken } from 'src/utils/token'

export interface UseSubscriptionOptions<TData, TVariables> {
  variables?: TVariables
  skip?: boolean
  requireAuth?: boolean
  onData?: (data: TData) => void
}

export const createSubscriptionHook = <
  TData,
  TVariables extends OperationVariables = OperationVariables,
>(
  document: TypedDocumentNode<TData, TVariables>,
) => {
  return (
    options?: UseSubscriptionOptions<TData, TVariables>,
  ): useSubscription.Result<TData> => {
    const { variables, skip, requireAuth = true, onData } = options ?? {}
    const shouldSkip = skip || (requireAuth && !getToken())

    const subscriptionOptions: useSubscription.Options<TData, TVariables> = {
      variables: variables as TVariables,
      skip: shouldSkip,
    }

    if (onData) {
      subscriptionOptions.onData = ({
        data,
      }: useSubscription.OnDataOptions<TData>) => {
        if (data.data) {
          onData(data.data)
        }
      }
    }

    return useSubscription(document, subscriptionOptions)
  }
}
